import cloneDeep from 'lodash-es/cloneDeep'
import { defineStore } from 'pinia'
import { v4 as uuid } from 'uuid'
import {
  NotificationType,
  Notification,
  NotificationState,
} from '@/legacy/types/notifications'

// CONST
const TIMEOUT_MS = 5000

const initialState = (): NotificationState => ({
  notification: null,
  persistentNotification: null,

  notifications: {},
  persistentNotifications: {},
})

export const useNotificationStore = defineStore('notification', {
  state: () => cloneDeep(initialState()),
  actions: {
    closeNotification(notificationId?: string) {
      this.notification = null

      if (notificationId && this.notifications[notificationId]) {
        delete this.notifications[notificationId]
      }
    },
    setNotification(notification: Notification) {
      if (notification.error && notification.type === NotificationType.DANGER) {
        console.error(notification.error)
      }

      this.notification = notification

      notification.uniqueId = uuid()

      if (notification.isPersistent) {
        this.persistentNotification = notification
        this.persistentNotifications[notification.uniqueId] = notification
      } else {
        this.notification = notification
        this.notifications[notification.uniqueId] = notification
        setTimeout(() => {
          this.closeNotification(notification.uniqueId)
        }, TIMEOUT_MS)
      }
    },
    setPersistentNotification(notification: Notification) {
      if (notification.error && notification.type === NotificationType.DANGER) {
        console.error(notification.error)
      }

      notification.isPersistent = true
      this.setNotification(notification)
    },
    closePersistentNotification(notificationId?: string) {
      this.persistentNotification = null

      if (notificationId && this.persistentNotifications[notificationId]) {
        delete this.persistentNotifications[notificationId]
      }
    },
  },
})

/**
 * Take a caught error, log it, and show a warning notification to the user
 * @param err
 * @param message
 */
export function logAndShowErrorMsg(err: any, message: string) {
  if (err instanceof Error) {
    console.error(err)
  }
  useNotificationStore().setNotification({
    message: message,
    type: NotificationType.DANGER,
  })
}
